<template>
    <uiPage :blok="blok" />
</template>

<script lang="ts" setup>
defineProps({ blok: Object });
</script>
